import React, { useState } from 'react';
import { AttachmentChanges, ReservationAttachments, validateAttachment } from '../../../utils/reservationAttachments';

interface Props {
  existing?: ReservationAttachments;
  changes: AttachmentChanges;
  onChange: (changes: AttachmentChanges) => void;
  disabled?: boolean;
  facilityName?: string;
}
export default function ReservationAttachmentFields({ existing, changes, onChange, disabled, facilityName = '' }: Props) {
  const [error, setError] = useState('');
  return <fieldset disabled={disabled} className="space-y-4 border-t pt-4">
    <legend className="text-sm font-bold">첨부 서류 (모두 선택)</legend>
    <p className="text-sm text-gray-500">대관신청서와 추가 서류를 각각 1개씩 첨부할 수 있습니다. 문서·이미지 파일별 최대 5MB.</p>
    {(['application', 'additional'] as const).map(kind => {
      const change = changes[kind];
      const url = kind === 'application' ? existing?.applicationFormUrl : existing?.fileUrl;
      const name = kind === 'application' ? existing?.applicationFormFileName : existing?.fileName;
      const label = kind === 'application' ? '대관신청서' : '추가 서류';
      return <div key={kind} className="space-y-2 rounded border p-3">
        <div className="flex justify-between text-sm font-medium"><span>{label} (선택)</span>
          {kind === 'application' && <a className="text-blue-700 underline" href={`https://futuremnc.mycafe24.com/bnfc/downloads/download.php?file=${facilityName.includes('족구장') ? '족구장_사용신청서.pdf' : '시설_사용신청서.pdf'}`} target="_blank" rel="noreferrer">양식 다운로드</a>}
        </div>
        {url && <div className="text-sm break-all">
          <a href={url} target="_blank" rel="noreferrer" className="text-blue-700 underline">{name || `${label} 다운로드`}</a>
          <span className="ml-2">{change.remove ? '저장 시 삭제' : change.file ? '저장 시 교체' : ''}</span>
          <button type="button" className="ml-3 text-red-700" onClick={() => onChange({ ...changes, [kind]: { file: null, remove: !change.remove } })}>{change.remove ? '삭제 취소' : '삭제'}</button>
        </div>}
        {change.file && <div className="text-sm break-all">선택: {change.file.name}<button type="button" className="ml-3 text-blue-700" onClick={() => onChange({ ...changes, [kind]: { file: null, remove: false } })}>선택 취소</button></div>}
        <input aria-label={`${label} 파일 선택`} type="file" accept="image/*,application/*" className="block w-full text-sm" onChange={event => {
          const file = event.target.files?.[0]; event.target.value = '';
          if (!file) return;
          const message = validateAttachment(file); setError(message || '');
          if (!message) onChange({ ...changes, [kind]: { file, remove: false } });
        }} />
      </div>;
    })}
    {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
  </fieldset>;
}
